import IntranetServiceInstance from 'src/services/api/intranetService';
import authService from 'src/services/api/auth';

/**
 * Fetches all bulletins from the API
 * @returns {Promise} Promise that resolves with the bulletins array
 */
export const fetchBulletins = async () => {
  const response = await IntranetServiceInstance.getBulletins();
  if (response.data.success && response.data.bulletins) {
    return response.data.bulletins;
  }
  throw new Error(response.data.message || 'Error al obtener las entradas');
};

/**
 * Creates or updates a bulletin entry
 * @param {Object} entryData - The entry data to save
 * @returns {Promise} Promise that resolves with the saved bulletin
 */
export const saveEntry = async (entryData) => {
  const payload = {
    id: entryData.id || undefined,
    title: entryData.title,
    type: entryData.type,
    content: entryData.content || null,
    link: entryData.link || null,
    assigned_to: entryData.assigned_to || undefined,
    is_active: true, // Default to active
  };

  const response = await IntranetServiceInstance.createEditBulletin(payload);

  if (response.data.success) {
    return {
      bulletin: response.data.bulletin,
      message: response.data.message || 'La operación se completó exitosamente.',
    };
  }
  throw new Error(response.data.message || 'Error al guardar la entrada');
};

/**
 * Marks a bulletin as read for a specific user
 * @param {number} bulletinId - The ID of the bulletin
 * @param {number} userId - The ID of the user
 * @returns {Promise} Promise that resolves with the response data
 */
export const markBulletinAsRead = async (bulletinId, userId) => {
  const response = await IntranetServiceInstance.markBulletinAsRead({
    bulletin_id: bulletinId,
    user_id: userId,
  });

  if (response.data.success) {
    return response.data;
  }
  throw new Error(response.data.message || 'Error al marcar como leído');
};

/**
 * Fetches all interactions from the API
 * @param {string|null} type - Optional type filter for interactions
 * @returns {Promise} Promise that resolves with the interactions array
 */
export const fetchInteractions = async (type = null) => {
  const params = type ? { type } : {};
  const response = await IntranetServiceInstance.getAllInteractions(params);

  if (response.data.success && response.data.interactions) {
    return response.data.interactions;
  }
  throw new Error(response.data.message || 'Error al obtener las interacciones');
};

/**
 * Fetches all users from the API
 * @returns {Promise} Promise that resolves with the users array
 */
export const fetchAllUsers = async () => {
  const response = await authService.getAllUsers();
  if (response.data.success && response.data.allUsers) {
    return response.data.allUsers;
  }
  throw new Error(response.data.message || 'Error al obtener los usuarios');
};
